import { createStore } from 'vuex';
import * as mainActions from './actions';
import * as mainMutations from './mutations';
import * as mainGetters from './getters';
import { state as mainState } from './state';
import {
  actions as preloadActions,
  getters as preloadGetters,
  state as preloadState,
  mutations as preloadMutations
} from './preload';

import { actions as headerActions } from './header';
import { actions as taskActions, getters as taskGetters, mutations as taskMutations, state as taskState } from './task';
import { actions as appActions, state as appState, mutations as appMutations } from './admin/application';
import { actions as labalActions } from './labels-common';
import { actions as sysvarActions, mutations as sysvarMutations } from './admin/system-variable';
import { actions as userLoginActions, state as userLoginState, mutations as userLoginMutations } from './user-login';

export const store = createStore({
  modules: {
    preload: {
      namespaced: true,
      actions: preloadActions,
      mutations: preloadMutations,
      state: () => preloadState(),
      getters: preloadGetters
    },
    'user-login': {
      namespaced: true,
      actions: userLoginActions,
      mutations: userLoginMutations,
      state: () => userLoginState()
    },
    task: {
      namespaced: true,
      actions: taskActions,
      getters: taskGetters,
      mutations: taskMutations,
      state: () => taskState()
    },
    header: {
      namespaced: true,
      actions: headerActions
    },
    'labels-common': {
      namespaced: true,
      actions: labalActions
    },
    'admin/application': {
      namespaced: true,
      actions: appActions,
      mutations: appMutations,
      state: () => appState()
    },
    'admin/system-variable': {
      namespaced: true,
      actions: sysvarActions,
      mutations: sysvarMutations
    }
  },
  namespaced: true,
  actions: mainActions,
  state: () => mainState(),
  alias: 'rootStore',
  mutations: mainMutations,
  getters: mainGetters,
  strict: false
});
